export const appConfig = {
  application: "enterprise shard 01",
  eyebrow: "Private operating system",
  title: "One tenant boundary. Every operating signal.",
  description:
    "A dedicated shard for rights, finance, talent, production, commerce, and audience operations—with the data plane kept private by design.",
  localSignals: ["Rights approvals", "Tour readiness", "Settlement queue", "Campaign health"],
} as const;
